export default __webpack_public_path__ + "static/media/right-img-mobile.14256c43.jpg";